// extracted by mini-css-extract-plugin
module.exports = {"item":"Style_item__38a4R","title":"Style_title__KYrZ1","detail":"Style_detail__1KDf2"};